import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { ConsumerUsersState } from "../../models/mp-admin/consumers-state";

const initialState: ConsumerUsersState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.consumerUsers.getApi, (state) => ({ ...state, loading: true })),
	on(MpAdminActions.consumerUsers.getSuccess, (state, action) => {
		return { users: action.users, loading: action.loading, allRetrieved: true };
	}),
	on(MpAdminActions.consumerUsers.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function ConsumerUsersReducer(
	state: ConsumerUsersState | undefined,
	action: Action
): ConsumerUsersState {
	return reducer(state, action);
}
